import { createFileRoute } from "@tanstack/react-router";
import { Smartphone } from "lucide-react";
import { useSiteSection } from "@/hooks/useSiteContent";
import { siteImageUrl } from "@/hooks/useSiteData";
import { SimplePlans } from "@/components/site/SimplePlans";
import { RichText } from "@/components/site/RichText";

export const Route = createFileRoute("/aplicativos")({
  head: () => ({
    meta: [
      { title: "Aplicativos e Streaming — Contato Internet" },
      {
        name: "description",
        content:
          "Assine pacotes com Deezer, Max, Paramount+, Skeelo e mais apps de streaming direto na sua fatura da Contato Internet.",
      },
      { property: "og:title", content: "Aplicativos e Streaming — Contato Internet" },
      {
        property: "og:description",
        content: "Streaming, música e leitura inclusos na sua fatura.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: AppsPage,
});

function AppsPage() {
  const apps = useSiteSection("apps");
  const logos = (apps.apps ?? []).filter((a) => a.name);

  return (
    <>
      <section className="bg-[linear-gradient(110deg,var(--brand-sky-deep),var(--brand-deep))] py-14 text-brand-deep-foreground sm:py-20">
        <div className="mx-auto max-w-7xl px-5">
          <p className="text-[0.7rem] font-extrabold uppercase tracking-[0.2em] text-brand-yellow">
            {apps.eyebrow}
          </p>
          <h1 className="mt-2 max-w-3xl text-3xl font-extrabold uppercase leading-tight sm:text-4xl">
            {apps.title}
          </h1>
          <p className="mt-3 max-w-2xl text-sm text-brand-sky sm:text-base">{apps.subtitle}</p>
        </div>
      </section>

      <section className="bg-background py-12 sm:py-16">
        <div className="mx-auto max-w-7xl px-5">
          <RichText
            text={apps.text}
            className="mx-auto max-w-3xl text-center text-sm leading-relaxed text-muted-foreground sm:text-base"
          />

          <SimplePlans
            items={apps.items}
            icon={Smartphone}
            waPrefix="Olá! Quero contratar o pacote de aplicativos"
          />

          {logos.length > 0 && (
            <div className="mt-14 rounded-[2rem] border border-border bg-card p-7 sm:p-10">
              <h2 className="text-center text-lg font-extrabold uppercase text-brand-deep">
                Apps disponíveis
              </h2>
              <ul className="mt-7 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
                {logos.map((app) => {
                  const src = siteImageUrl(app.image);
                  return (
                    <li
                      key={app.name}
                      className="grid h-24 place-items-center rounded-2xl bg-secondary px-4 text-center"
                    >
                      {src ? (
                        <img
                          src={src}
                          alt={app.name}
                          loading="lazy"
                          className="max-h-12 w-full object-contain"
                        />
                      ) : (
                        <span className="text-sm font-extrabold uppercase text-primary">
                          {app.name}
                        </span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
